<app-exercise-search
  size="compact"
  [formControl]="searchCtrl"
  (exerciseSelected)="stopEditing()"
>
</app-exercise-search>
